import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Input } from 'semantic-ui-react'

import { cn } from '@repo/utils'

import { ChildrenSchema } from 'utils'

import Chip from '../Chip'

import styles from './index.css'

class ChipsFilter extends PureComponent {
  onFilterClick = ({ currentTarget: { value } }) => this.props.onFilterClick(this.props.filters[value])

  renderChips = () => {
    const { filters } = this.props
    const chipsList = []

    filters.forEach((filter, index) =>
      chipsList.push(
        <Chip
          key={filter.title}
          active={filter.active}
          ariaLabel={filter.title}
          className={styles.filter}
          onClick={this.onFilterClick}
          value={index}
        >
          {!!filter.icon && <span className={styles.icon}>{filter.icon}</span>}
          <small>{filter.title}</small>
        </Chip>,
      ),
    )

    return <div className={styles.filtersList}>{chipsList}</div>
  }

  renderSearch = () => (
    <div className={cn(styles.search, this.props.searchHighlight && styles.searchHighlight)}>
      <Input
        defaultValue={this.props.searchText}
        icon="search"
        onChange={this.props.onSearchChange}
        placeholder="Filtrar..."
      />
    </div>
  )

  render() {
    const { ariaLabel, className, onSearchChange } = this.props

    return (
      <div aria-label={ariaLabel} className={className}>
        {!!onSearchChange && this.renderSearch()}
        {this.renderChips()}
      </div>
    )
  }
}

ChipsFilter.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      icon: ChildrenSchema,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onFilterClick: PropTypes.func.isRequired,

  className: PropTypes.string,
  onSearchChange: PropTypes.func,
  searchHighlight: PropTypes.bool,
  searchText: PropTypes.string,
}

export default ChipsFilter
